module.exports = __webpack_public_path__ + "img/e4af5fc.jpg";